import { render, staticRenderFns } from "./TitleScoreList.vue?vue&type=template&id=25072d64"
import script from "./TitleScoreList.vue?vue&type=script&lang=ts"
export * from "./TitleScoreList.vue?vue&type=script&lang=ts"
import style0 from "./TitleScoreList.vue?vue&type=style&index=0&id=25072d64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports